module.exports = __webpack_public_path__ + "img/floor_OG2.1c020d11.svg";